import * as React from 'react';

const ProjectsToolboxContext = React.createContext<{
    LazyTimeStreamProjectsToolbox?: React.FunctionComponent<{
        hideProjectsToolbox: () => void;
    }>;
    LazyTimeStreamProjectsToolboxHeaderButton?: React.FunctionComponent<{
        hasSelectedAssets: boolean;
        clearSelectedAssets: () => void;
        headerButtonRef: React.RefObject<HTMLButtonElement> | null;
        headerButtonClass: string;
        showProjectsToolbox: () => void;
    }>;
}>({});

ProjectsToolboxContext.displayName = 'ProjectsToolboxContext';

export const ProjectsToolboxProvider = ProjectsToolboxContext.Provider;

export default function useProjectsToolbox() {
    return React.useContext(ProjectsToolboxContext);
}
